module.exports = __webpack_public_path__ + "static/media/08_ladoalado.a24cebf4.jpg";